module.exports = {"632223100":"三角城镇","632223101":"西海镇","632223200":"金滩乡","632223201":"哈勒景蒙古族乡","632223202":"青海湖乡","632223203":"甘子河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632223.json
// module id = 3134
// module chunks = 0